import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <>
      <div className="loaderspin"></div>
    </>
  );
};

export default Loader;
